import { useQuery } from '@tanstack/react-query';
import { backendServices } from 'common';
import { useMemo } from 'react';

/**
 * TODO: Consolidate with common's useGetERPs hook in the future
 */
export function useERPSystems() {
    const { data, isLoading, isFetching, error } = useQuery(['ERPSystems'], async () => {
        const api = new backendServices.Apis.ERPApi();
        const res = await api.getERPSystems();

        return res.data;
    });

    return {
        data,
        isLoading: isLoading || isFetching,
        error,
    };
}

export function useERPOptions(erpList: backendServices.ViewModels.ERPViewModel[]) {
    const erpOptions = useMemo(() => {
        const filteredErpList = erpList.filter((erp) => erp.Active);
        return filteredErpList.reduce<Record<string, any>>((record, erp) => {
            return { ...record, [erp.ERPType_US]: erp.Id };
        }, {});
    }, [erpList]);

    erpOptions.Other = 0;

    return erpOptions;
}
